import React from 'react'
import { CloudinaryVideoProps, PreloadOptions } from './CloudinaryVideo.types'

const videoFormats = [
  {
    fileExtension: 'mp4',
    urlParams: 'ac_aac,f_mp4,q_auto,vc_h264',
    type: 'video/mp4'
  },
  {
    fileExtension: 'webm',
    urlParams: 'ac_vorbis,q_auto,vc_vp8',
    type: 'video/webm'
  },
  {
    fileExtension: 'ogv',
    urlParams: 'ac_vorbis,q_auto,vc_theora',
    type: 'video/ogg'
  }
]

const CloudinaryVideo = (
  {
    className = '',
    cloudName,
    publicId,
    autoplay,
    controls,
    loop,
    muted,
    playsinline = true,
    preload = PreloadOptions.metadata
  }: CloudinaryVideoProps,
  ref: React.Ref<HTMLVideoElement> | undefined
) => {
  return (
    <video
      ref={ref}
      className={`h-full w-full ${className}`}
      autoPlay={autoplay}
      controls={controls}
      loop={loop}
      muted={muted}
      playsInline={playsinline}
      preload={preload}
      poster={`https://res.cloudinary.com/${cloudName}/video/upload/f_auto/${publicId}.jpg`}
    >
      {videoFormats.map((format) => (
        <source
          key={format.fileExtension}
          src={`https://res.cloudinary.com/${cloudName}/video/upload/${format.urlParams}/${publicId}.${format.fileExtension}`}
          type={format.type}
        />
      ))}
    </video>
  )
}

const VideoForwardRef = React.forwardRef(CloudinaryVideo)

export default VideoForwardRef
